<template>
  <div class="subScription">
    <div class="menu">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#f6f8f9"
        router>
        <el-menu-item index="/configuration/miniApp/index">
          <i class="el-icon-house"></i>
          <span slot="title">微信小程序</span>
        </el-menu-item>
        <el-menu-item index="/configuration/miniApp/aliconfig" v-if="showTest">
          <i class="el-icon-document"></i>
          <span slot="title">支付宝小程序</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <div class="cont">
        <transition name="el-fade-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  data() {
    return {
      show: true,
      isCollapse: false,
      showTest: false,
    };
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
    change() {
      this.isCollapse = !this.isCollapse;
    },
    init(){
      var base = localStorage.getItem('baseStatus')
      var appid = localStorage.getItem('app_id')
      if((base == 'test' && appid == '389') || (base == 'online' && appid == '413')){
        this.showTest = true;
      }
    }
  },
  mounted(){
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.subScription{
  min-width: 1120px;
  height: 100%;
  overflow: auto;
  display: flex;
  .menu{
    padding-top:20px;
    border-right: 1px solid #eee;
    .el-menu{
      border:none;
    }
  }
  .content{
    flex:1;
  }
}
</style>
